import React from "react"
import Section from "./section"
import { Link } from "gatsby"

const Partners = ({ data }) => {
  const {
    field_heading,
    field_subhead,
    field_desc,
    relationships,
    anchor,
  } = data

  const logos = relationships.field_images

  //console.log(logos.length)

  return (
    <Section
      name="partners"
      id={anchor}
      heading={field_heading}
      subhead={field_subhead}
    >
      {!!field_desc && (
        <div
          className="page__blurb text-left"
          dangerouslySetInnerHTML={{ __html: field_desc.processed }}
        ></div>
      )}
      {!!logos && (
        <div className="partners-logos d-flex align-items-center justify-content-center">
          {logos.map((logo, index) => (
            <>
              {!!logo.relationships && (
                <div className="logo">
                  {logo.field_url && (
                    <Link to={logo.field_url.uri}>
                      <img
                        src={
                          logo.relationships.field_media_image.localFile
                            .childImageSharp.fixed.src
                        }
                        alt="logo"
                      />
                    </Link>
                  )}

                  {!logo.field_url && (
                    <img
                      src={
                        logo.relationships.field_media_image.localFile
                          .childImageSharp.fixed.src
                      }
                      alt="logo"
                    />
                  )}
                </div>
              )}
            </>
          ))}
        </div>
      )}
    </Section>
  )
}
export default Partners
